import { render } from "./schedulemodel.vue?vue&type=template&id=1ed75923"
import script from "./schedulemodel.vue?vue&type=script&lang=js"
export * from "./schedulemodel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__